const toggles = document.querySelectorAll<HTMLElement>(".--js-toggle-class");

toggles.forEach(toggle => {
  const toggleClassTargetSelector = toggle.dataset.toggleClassTarget ?? "";
  const onClickOutToggleClass = (toggle.dataset.toggleClassClickout === "true");
  const onOnlyParentsToggleClass = (toggle.dataset.toggleClassOnlyParent === "true");
  const toggleClassName = toggle.dataset.toggleClassName;

  if (!toggleClassName) return;

  const toggleClassTargets = Array.from(document.querySelectorAll<HTMLElement>(toggleClassTargetSelector)).filter((toggleClassTarget) => {
    return (onOnlyParentsToggleClass && toggleClassTarget.contains(toggle)) || !onOnlyParentsToggleClass;
  });

  if (toggleClassTargets.length <= 0) return;

  toggle.addEventListener("click", (event) => {toggleClassOnTarget(event)})

  if (onClickOutToggleClass) {
    document.addEventListener("click", (event) => {removeClassOnTarget(event)})
  }

  const toggleClassOnTarget = (event : MouseEvent) => {
    event?.preventDefault();
    toggleClassTargets?.forEach(toggleTarget => toggleTarget.classList.toggle(toggleClassName));
  }

  const removeClassOnTarget = (event : MouseEvent) => {
    let isEventTargetChildOfTarget;

    toggleClassTargets.forEach(toggleTarget => {
      if (toggleTarget.contains(event?.target as Node) || toggle.contains(event?.target as Node)) isEventTargetChildOfTarget = true;
    })

    if (isEventTargetChildOfTarget) return;

    toggleClassTargets?.forEach(target => target.classList.remove(toggleClassName));
  }
});

